import { schema } from "normalizr";

const SessionSchema = new schema.Entity("sessions");
const SessionArraySchema = new schema.Array(SessionSchema);

export { SessionSchema, SessionArraySchema };